import { useEffect, useState } from "react";
import Box from "@mui/material/Box";
import { Alert, Snackbar, Stack, Typography } from "@mui/material";
import Table from "@mui/material/Table";
import TableBody from "@mui/material/TableBody";
import TableCell from "@mui/material/TableCell";
import TableContainer from "@mui/material/TableContainer";
import TableHead from "@mui/material/TableHead";
import TableRow from "@mui/material/TableRow";
import { Checkbox } from "@mui/material";
import Paper from "@mui/material/Paper";
import { createTheme, ThemeProvider } from "@mui/material/styles";
import DatePicker from "react-datepicker";
import "react-datepicker/dist/react-datepicker.css";
import TablePagination from "@mui/material/TablePagination";
import { useDispatch } from "react-redux";
import { getCurrentMonth } from "../../../Tracks/DeliveryLeadership/app/DeliveryLeadershipSlice";
import { useSelector } from "react-redux";
import TLFileUpload from "./TLFileUpload";
import "./CourseMasterData.css";
import { getTrainingListMonthWise } from "../../../Tracks/DeliveryLeadership/app/DeliveryLeadershipSlice";
import SearchCourse from "./SearchCourse";
import { NominationListDelete } from "../../../Tracks/DeliveryLeadership/app/DeliveryLeadershipSlice";
import DeleteIcon from "@mui/icons-material/DeleteOutlineOutlined";
import { IconButton } from "@mui/material";
import { IoMdDownload } from "react-icons/io";
import LeftArrow from "@mui/icons-material/KeyboardArrowLeft";
import RightArrow from "@mui/icons-material/KeyboardArrowRight";

function formatDate(dateString) {
  const date = new Date(dateString);

  const day = String(date.getDate()).padStart(2, "0");
  const month = String(date.getMonth() + 1).padStart(2, "0"); // Months are 0-based
  const year = date.getFullYear();

  return `${day}-${month}-${year}`;
}

const THTrainingList = () => {
  const [page, setPage] = useState(0);
  const dispatch = useDispatch();
  const trainingList = useSelector(
    (state) => state?.deliveryLeadership?.monthWIseTrainingList
  );
  const [month, setMonth] = useState("");
  const currentMonthIndex =
    useSelector((state) => state?.deliveryLeadership?.currentMonthIndex) ?? false;
  const [filteredTrainingListStatus, setFilteredTrainingListStatus] =
    useState(0);
  const [filteredTrainingList, setFilteredTrainingList] = useState([]);
  const [isSearchPerformed, setIsSearchPerformed] = useState(false);
  const [rowsPerPage, setRowsPerPage] = useState(10);
  const [selectedRow, setSelectedRow] = useState([]);
  const [isAlert, setIsAlert] = useState(false);
  const [dataDelete, setDataDalete] = useState(false);
  const dataSuccess = useSelector(
    (state) => state?.deliveryLeadership?.isDataSentSuccess
  );

  //Selecting month and Date

  const [selectedDate, setSelectedDate] = useState(new Date());
  const [year, setYear] = useState(new Date().getFullYear());
  const handledateChange = (value) => {
    setSelectedDate(value);
    const date = new Date(value);
    const month = date.getMonth() + 1; // Months are zero-based, so add 1
    const year = date.getFullYear();
    setMonth(month);
    setYear(year);
    dispatch(getTrainingListMonthWise(month, year));
    setPage(0);
  };

  const handleChangePage = (event, newPage) => {
    setPage(newPage);
  };
  const handleChangeRowsPerPage = (event) => {
    setRowsPerPage(parseInt(event.target.value, 10));
    setPage(0);
  };

  const numSelected = selectedRow.length;
  const rowCount = trainingList.length;

  const theme = createTheme({
    typography: {
      fontFamily: "Graphik-Regular",
    },
  });
  useEffect(() => {
    if (currentMonthIndex && currentMonthIndex != undefined) {
      dispatch(getTrainingListMonthWise(currentMonthIndex, year));
    }
  }, [currentMonthIndex]);
  useEffect(() => {
    dispatch(getCurrentMonth());
    setMonth(currentMonthIndex);
  }, [currentMonthIndex]);

  const handleDataDelete = (sessionCode) => {
    try {
      if (selectedRow.length > 0) {
        setIsAlert(true);
        setDataDalete(true);
        dispatch(NominationListDelete(sessionCode, month, year));
      } else {
        setIsAlert(true);
        setDataDalete(false);
      }
    } catch (err) {
      console.log("err", err);
    }
    setSelectedRow([]);
  };
  const handleSelectAllClick = (event) => {
    if (event.target.checked) {
      const newSelecteds = trainingList.map((n) => n.sessionCode);
      setSelectedRow(newSelecteds);
      return;
    }
    setSelectedRow([]);
  };

  const handleSampleSessionsDownload = async () => {
    try {
      let fileUrl = process.env.PUBLIC_URL + "/template/sample_sessions_DL.xlsx";
      let fileName = `sample_sessions_DL.xlsx`;
      const response = await fetch(fileUrl);
      const blob = await response.blob();
      const blobUrl = window.URL.createObjectURL(new Blob([blob]));
      const link = document.createElement("a");
      link.href = blobUrl;
      link.download = `${fileName}`;
      link.target = "_blank";
      document.body.appendChild(link);
      link.click();
      document.body.removeChild(link);
      window.URL.revokeObjectURL(blobUrl);
    } catch (error) {
      console.error("Error downloading the file:", error);
    }
  };

  return (
    <>
      <ThemeProvider theme={theme}>
        <div className="upload_section">
          <h3 className="upload_section_header">Training List</h3>
          <p className="upload_section_para">
            This section allows you to review the list of scheduled training
            sessions and upload the upcoming training session list which will be
            available for business teams to upload their nominations.
          </p>
          <p className="upload_section_para">
            You also have options to filter the scheduled training for a
            specific month.
          </p>
        </div>
        <Stack
          direction={"row"}
          justifyContent="space-between"
          sx={{ marginBottom: "20px" }}
        >
          <TLFileUpload/>
          <SearchCourse
            trainingList={trainingList}
            setFilteredTrainingList={setFilteredTrainingList}
            setFilteredTrainingListStatus={setFilteredTrainingListStatus}
            isSearchPerformed={isSearchPerformed}
            setIsSearchPerformed={setIsSearchPerformed}
          />
          <div
            style={{
              display: "flex",
              flexDirection: "column",
              width: "14%",
              gap: "20px",
            }}
          >
            <button
              className="course_master__sample_file_download"
              onClick={handleSampleSessionsDownload}
            >
              <span style={{ fontSize: "1vw" }}>
                {" "}
                Download Sample{" "}
                <IoMdDownload
                  style={{ "verticalAlign": "text-bottom", marginLeft: "2px" }}
                />
              </span>
            </button>
            <Box
              className="select_month_year_section"
              style={{ width: "100%", display: "flex" }}
            >
              <div
                style={{
                  display: "flex",
                  alignItems: "center",
                  justifyContent: "flex-start",
                  gap: "10px",
                }}
                className="session__month_selector"
              >
                <DatePicker
                  selected={selectedDate}
                  placeholderText="MM/YYYY"
                  className="month-year-picker"
                  onChange={(date) => handledateChange(date)}
                  dateFormat="MMMM, yyyy"
                  showMonthYearPicker
                  renderCustomHeader={({ date, changeYear }) => (
                    <div className="custom-header">
                      <LeftArrow
                        className="arrow"
                        onClick={() => changeYear(date.getFullYear() - 1)}
                      />
                      <span>
                        {date.toLocaleString("default", { month: "long" })}{" "}
                        {date.getFullYear()}
                      </span>
                      <RightArrow
                        className="arrow"
                        onClick={() => changeYear(date.getFullYear() + 1)}
                      />
                    </div>
                  )}
                />
              </div>
            </Box>
          </div>
        </Stack>
        {trainingList.length != 0 ? (
          <Box className="upload_table">
            <TableContainer component={Paper}>
              <Table
                sx={{ minWidth: 550 }}
                size="small"
                aria-label="a dense table"
              >
                <TableHead>
                  <TableRow>
                    {
                      <TableCell sx={{ minWidth: 80 }}>
                        <Checkbox
                          indeterminate={
                            numSelected > 0 && numSelected < rowCount
                          }
                          checked={rowCount > 0 && numSelected === rowCount}
                          onChange={handleSelectAllClick}
                          style={{ color: "#fff", padding: "0px 5px 0px 0px" }}
                        />
                        <IconButton
                          onClick={() => handleDataDelete(selectedRow)}
                          sx={{ padding: "0px" }}
                          title="Delete"
                        >
                          <DeleteIcon sx={{ color: "#fff" }} />
                        </IconButton>
                      </TableCell>
                    }
                    <TableCell align="center">Sl No</TableCell>
                    <TableCell align="center">Course Code</TableCell>
                    <TableCell align="center">Session Code</TableCell>
                    <TableCell align="center">Course Name</TableCell>
                    <TableCell align="center">Start Date </TableCell>
                    <TableCell align="center">End Date</TableCell>
                    <TableCell align="center">Session Type</TableCell>
                    <TableCell align="center">Duration</TableCell>
                    {/* <TableCell align="center">Delete</TableCell> */}
                    {/* <TableCell align="center" sx={{ width: "10%" }}></TableCell> */}
                  </TableRow>
                </TableHead>
                <TableBody>
                  {trainingList.length != 0 &&
                    filteredTrainingListStatus === 0 && (
                      <ShowTrainingList
                        trainingList={trainingList}
                        rowsPerPage={rowsPerPage}
                        page={page}
                        selectedRow={selectedRow}
                        setSelectedRow={setSelectedRow}
                        numSelected={numSelected}
                        rowCount={rowCount}
                      />
                    )}
                  {trainingList.length != 0 &&
                    filteredTrainingListStatus === 1 && (
                      <ShowTrainingList
                        trainingList={filteredTrainingList}
                        rowsPerPage={rowsPerPage}
                        page={page}
                        selectedRow={selectedRow}
                        setSelectedRow={setSelectedRow}
                        numSelected={numSelected}
                        rowCount={rowCount}
                      />
                    )}
                  {trainingList.length != 0 &&
                    filteredTrainingListStatus === 1 &&
                    filteredTrainingList.length === 0 && (
                      <TableRow>
                        <TableCell>Searched courses not found.</TableCell>
                      </TableRow>
                    )}
                </TableBody>
              </Table>
            </TableContainer>
            <TablePagination
              className="manageNomination_pagination"
              component="div"
              count={
                isSearchPerformed
                  ? filteredTrainingList && filteredTrainingList.length > 0
                    ? filteredTrainingList.length
                    : 0
                  : trainingList.length
              }
              page={page}
              onPageChange={handleChangePage}
              rowsPerPage={rowsPerPage}
              onRowsPerPageChange={handleChangeRowsPerPage}
              sx={{ width: "100% !important" }}
            />
          </Box>
        ) : (
          <Stack
            justifyContent={"center"}
            alignItems={"center"}
            sx={{ marginTop: "30px", marginBottom: "100px" }}
          >
            <Stack
              spacing={2}
              justifyContent={"center"}
              alignItems={"center"}
              sx={{
                border: "solid 1px #DEDEDE",
                borderRadius: "5px",
                width: "70%",
                padding: "30px",
              }}
            >
              <img
                style={{ width: "100px" }}
                src="/images/POC/norecords.png"
              ></img>
              <Stack direction={"row"} spacing={1}>
                <img
                  style={{ width: "20px", height: "20px", marginTop: "3px" }}
                  src="/images/POC/norecordsalert.png"
                ></img>
                <Typography sx={{ fontSize: "20px" }}>
                  Training List for this month has not published yet!!!
                </Typography>
              </Stack>
            </Stack>
          </Stack>
        )}
        <div>
          {isAlert && selectedRow.length === 0 && !dataDelete && (
            <Snackbar
              open={isAlert}
              onClose={() => setIsAlert(false)}
              anchorOrigin={{ vertical: "top", horizontal: "right" }}
              style={{ marginTop: "200px" }}
              autoHideDuration={4000}
            >
              <Alert severity="warning" onClose={() => setIsAlert(false)}>
                please select rows to delete
              </Alert>
            </Snackbar>
          )}
          {dataSuccess && isAlert && dataDelete && (
            <Snackbar
              open={isAlert}
              autoHideDuration={4000}
              onClose={() => setIsAlert(false)}
              anchorOrigin={{ vertical: "top", horizontal: "right" }}
              style={{ marginTop: "200px" }}
            >
              <Alert severity="success" onClose={() => setIsAlert(false)}>
                Delete was succussfull.!
              </Alert>
            </Snackbar>
          )}
        </div>
      </ThemeProvider>
    </>
  );
};

function ShowTrainingList({
  trainingList,
  rowsPerPage,
  page,
  selectedRow,
  numSelected,
  rowCount,
  setSelectedRow,
  handleDataDelete,
}) {
  const handleRowClick = (event, sessionCode) => {
    const selectedIndex = selectedRow.indexOf(sessionCode);
    let newSelected = [];

    if (selectedIndex === -1) {
      newSelected = newSelected.concat(selectedRow, sessionCode);
    } else if (selectedIndex === 0) {
      newSelected = newSelected.concat(selectedRow.slice(1));
    } else if (selectedIndex === selectedRow.length - 1) {
      newSelected = newSelected.concat(selectedRow.slice(0, -1));
    } else if (selectedIndex > 0) {
      newSelected = newSelected.concat(
        selectedRow.slice(0, selectedIndex),
        selectedRow.slice(selectedIndex + 1)
      );
    }
    setSelectedRow(newSelected);
  };
  return (
    <>
      {trainingList
        .slice(page * rowsPerPage, page * rowsPerPage + rowsPerPage)
        .map((row, index) => (
          <TableRow key={row.sno}>
            <TableCell padding="checkbox" align="center" scope="row">
              <Checkbox
                checked={selectedRow.indexOf(row.sessionCode) !== -1}
                onChange={(event) => handleRowClick(event, row.sessionCode)}
              />
            </TableCell>
            <TableCell align="center" scope="row">
              {row.sno}.
            </TableCell>
            <TableCell align="center" scope="row">
              {row.courseCode}
            </TableCell>
            <TableCell align="center">{row.sessionCode}</TableCell>
            <TableCell align="center">{row.courseName}</TableCell>
            <TableCell align="center">{formatDate(row.startDate)}</TableCell>
            <TableCell align="center">{formatDate(row.endDate)}</TableCell>
            <TableCell align="center">{row.sessionType}</TableCell>
            <TableCell align="center">{row.duration}</TableCell>
            {/* 
      <TableCell align="center"></TableCell> */}
          </TableRow>
        ))}
    </>
  );
}

export default THTrainingList;
